import { FormGroup, Switch } from "@blueprintjs/core";
import type { ExtraFieldTypeBoolean } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldBooleanProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeBoolean;
};

function ServiceDataFormFieldBooleanContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldBooleanProps) {
  const checked = useMemo<boolean>(
    () =>
      get(data, field.source) ??
      field.defaultValue ??
      field.metadata?.allowOverride?.defaultValue ??
      false,
    [
      data,
      field.defaultValue,
      field.metadata?.allowOverride?.defaultValue,
      field.source,
    ],
  );

  return (
    <FormGroup>
      <Switch
        label={field.label ?? "No Label"}
        checked={checked}
        onChange={() =>
          onSourceChanged((draft) => {
            set(draft, field.source, !checked);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldBoolean({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeBoolean") {
    return (
      <ServiceDataFormFieldBooleanContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
